import styled from '@emotion/styled';
import { Pagination } from '@kep-ui-kit/ui-components';
import { ChangeEvent, useCallback, useEffect, useMemo } from 'react';

import { pageSizes } from '../constants/page-sizes';

import { useCustomSearchParams } from '@selfserve/react-hooks';
import { StyledSelectMenu } from '@selfserve/react-ui';
import { IIndexSignature } from '@selfserve/react-utils';

const StyledPaginationControllerContainer = styled('div')`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const StyledPaginationControllerMenu = styled(StyledSelectMenu)`
  padding: 4px 0;
  margin-left: 16px;
`;

export const AdminPaginationController = () => {
  const [query, setQuery] = useCustomSearchParams();
  const page = useMemo(() => +query['pageIndex'], [query['pageIndex']]);
  const size = useMemo(() => +query['pageSize'], [query['pageSize']]);

  useEffect(() => {
    if (!page || page < 1) updateQuery({ pageIndex: '1' });
    if (page > 1000) updateQuery({ pageIndex: '1000' });
    if (!size) updateQuery({ pageSize: '1000' });
    if (size) {
      const currentSize = pageSizes.find(({ value }) => value === String(size));
      if (!currentSize) updateQuery({ pageSize: '1000' });
    }
  }, [page, size]);

  const handlePaginationChange = useCallback(
    (event: ChangeEvent<unknown>, page: number) => {
      updateQuery({ pageIndex: String(page) });
    },
    [setQuery]
  );

  const handleSizeChange = useCallback(
    (pageSize: string) => {
      updateQuery({ pageSize });
    },
    [setQuery]
  );

  const updateQuery = useCallback(
    (newValue: IIndexSignature<string>) =>
      setQuery((prevValue) => ({ ...prevValue, ...newValue })),
    [setQuery]
  );

  return (
    <StyledPaginationControllerContainer>
      <Pagination
        count={1000}
        boundaryCount={3}
        page={page || -1}
        onChange={handlePaginationChange}
      />
      <StyledPaginationControllerMenu
        fullWidth
        options={pageSizes}
        value={String(size)}
        defaultValue={String(size)}
        onChange={handleSizeChange}
        size="small"
      />
    </StyledPaginationControllerContainer>
  );
};
